import { ReactNode } from "react";

import { Tooltip } from "@stellar/design-system";

import "./styles.scss";

/** The one message every action frozen by the co-signing pause shows. */
export const CO_SIGNING_PAUSE_MESSAGE = "Not available during the co-signing pause";

type PausedActionTooltipProps = {
  /** When false the children render untouched. */
  isPaused: boolean;
  children: ReactNode;
  placement?: "top" | "bottom" | "left" | "right";
};

/**
 * Wraps a control that is disabled during the co-signing pause so the reason
 * shows on hover. Disabled buttons swallow pointer events, so the wrapper
 * span carries the hover and the `not-allowed` cursor.
 */
export const PausedActionTooltip = ({
  isPaused,
  children,
  placement = "top",
}: PausedActionTooltipProps) => {
  if (!isPaused) return <>{children}</>;

  return (
    <Tooltip
      placement={placement}
      triggerEl={
        <span className="PausedActionTooltip" aria-label={CO_SIGNING_PAUSE_MESSAGE}>
          {children}
        </span>
      }
    >
      {CO_SIGNING_PAUSE_MESSAGE}
    </Tooltip>
  );
};
